var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.3,40c1.1,2.5,3.6,4.2,6.4,4.2c3.9,0,7-3.2,6.9-7.1c-0.1-3.8-3.4-6.8-7.4-6.8H14.4c-3.8,0-7,2.7-7.3,6.3   c-0.4,4.2,3,7.6,6.9,7.6c2.8,0,5.2-1.6,6.3-4.2C23,34.9,33.6,35.6,35.3,40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,44.7c1.5-2.2,4.5-2.1,6,0c2.4,3.6,6.5,5.7,10.8,5.7c7.4,0,13.2-6.1,13.1-13.3c-0.1-7.1-6.2-12.8-13.5-12.8H14.4   C7.6,24.2,1.7,29.4,1.1,36c-0.7,7.9,5.5,14.3,13.1,14.3C18.4,50.4,22.4,48.2,24.9,44.7z M22.2,40.9c-1.4,3.2-4.6,5.2-8.1,5.2   c-5.1,0-9.4-4.4-8.9-9.7c0.4-4.5,4.5-8,9.2-8h26.8c5,0,9.2,3.9,9.3,8.7c0.1,4.9-3.8,9-8.9,9c-3.5,0-6.7-2-8.1-5.2   C30.5,37.3,25.1,37.4,22.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,21.1h-8.3c-0.5,0-1,0.4-1,1c0,2.5,1.8,4.6,4.1,5v30.4c0,2.1-1.8,3.9-3.9,3.9H32.7c-2.2,0-3.9-1.8-3.9-3.9v-3.2H30   c0.3,0,0.7-0.2,0.8-0.5l2.3-4c0.2-0.3,0.2-0.7,0-1s-0.5-0.5-0.8-0.5h-8.7c-0.3,0-0.7,0.2-0.8,0.5c-0.2,0.3-0.2,0.7,0,1l2.3,4   c0.2,0.3,0.5,0.5,0.8,0.5h1.1v3.2c0,3.2,2.6,5.8,5.8,5.8H55c3.2,0,5.8-2.6,5.8-5.8V27.1c2.4-0.4,4.1-2.5,4.1-5   C65,21.6,64.6,21.1,64,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,15.6c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1C58.2,12.5,56.8,13.9,56.8,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,10.3c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8C50.1,8.6,51.8,10.3,53.9,10.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScub);
export default __webpack_public_path__ + "static/media/SCUB.69d5450ee9b2efc8abe2add874aa02ae.svg";
export { ForwardRef as ReactComponent };